var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFollowArray(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Groupe_3178",
    "data-name": "Groupe 3178",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 27.854,
    viewBox: "0 0 30 27.854",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3345",
    "data-name": "Rectangle 3345",
    width: 30,
    height: 27.854,
    transform: "translate(0 0)",
    fill: "rgba(0,0,0,0)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3177",
    "data-name": "Groupe 3177",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1999",
    "data-name": "Trac\\xE9 1999",
    d: "M10.3,0H4.091A4.109,4.109,0,0,0,0,4.124V23.733a4.109,4.109,0,0,0,4.089,4.121H25.911A4.11,4.11,0,0,0,30,23.733V4.124A4.111,4.111,0,0,0,25.913,0H10.3Zm1.83,1.98H25.912A2.139,2.139,0,0,1,28.04,4.124V9.977H1.963V4.124A2.139,2.139,0,0,1,4.091,1.98h8.04Zm-.853,9.365h7.883v6.481H11.278Zm7.883,14.533H11.278V19.194h7.883ZM9.92,17.826H1.963V11.345H9.92Zm10.6-6.481h7.522v6.481H20.52ZM1.963,23.733V19.194H9.92v6.684H4.09a2.139,2.139,0,0,1-2.127-2.145m23.95,2.144H20.519V19.193h7.522v4.539a2.139,2.139,0,0,1-2.128,2.146Z",
    fill: "#3e3e3e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3342",
    "data-name": "Rectangle 3342",
    width: 1.358,
    height: 10.201,
    transform: "translate(9.92 1.144)",
    fill: "#3e3e3e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3343",
    "data-name": "Rectangle 3343",
    width: 26.077,
    height: 2.603,
    transform: "translate(1.963 1.522)",
    fill: "#3e3e3e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3344",
    "data-name": "Rectangle 3344",
    width: 1.358,
    height: 10.201,
    transform: "translate(19.161 1.144)",
    fill: "#3e3e3e"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFollowArray);
export default __webpack_public_path__ + "static/media/FollowArray.946e8a6143776c0a6f2caac804556b7a.svg";
export { ForwardRef as ReactComponent };